import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { OfferUrgency } from './components/OfferUrgency';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    // If fbq already initialized (e.g. by a prior mount), just track and exit.
    if (w.fbq) {
      try {
        w.fbq('track', 'PageView');
      } catch {
        /* no-op */
      }
      return;
    }
    // Build the fbq queue stub (adapted from Meta's official snippet, but DOM-safe).
    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Safely inject the Meta Pixel script — avoid getElementsByTagName('script')[0].parentNode,
    // which can be undefined inside sandboxed previews.
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const parent = document.head || document.body || document.documentElement;
    if (parent) parent.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-pastel-white font-body text-gray-800 overflow-x-hidden" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <OfferUrgency data-id="element-9" />
      <OfferSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalCta data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}